import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import FinanceChart from "./userDetails-comp/FinanceChart";
import { Modal } from "react-bootstrap";
import usePermission from "../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import { EmployeePayrollSalaryStructure, PayrollSalaryStructureFormat, PayrollSalaryStructureFormatBackup, UploadSalaryDataBulk } from "./userDetails-comp/SalaryStructureComponents";
import { CustomTooltip, formatCurrencyIndian, formatRoundoff2D, formatRoundoffComplete, getMonthYearNameFromDate, handleAllError, handleErrorToast } from "../CustomFunctions";
import { Eye } from "../AllSvg";
import { EmployeeAdvanceSlipsTable } from "../AdvanceManagement/AdvanceTables";
import { Arreartable } from "../settings/HRActivities/HRActivitiesTables";

const AddSalaryDetails = ({
  code,
  salaryData,
  getSalaryData,
  getSalaryStructure,
}) => {

  const [show, setShow] = useState(false);


  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setFormData(salaryData.emp_code ? salaryData : {
      emp_code: code,
      basicsalary: "",
      hra: "",
      transport: "",
      specialallowance: "",
      bonus: "",
    });

  };

  const [formData, setFormData] = useState({
    emp_code: code,
    basicsalary: "",
    hra: "",
    transport: "",
    specialallowance: "",
    bonus: "",
  });
  console.log("formData")
  console.log(formData.emp_code)
  console.log("salaryData")
  console.log(salaryData.emp_code ? "sa" : "as")
  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "basicsalary",
      "hra",
      "transport",
      "specialallowance",
      "bonus",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ?  ************** Validation End **************  ! //

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => { }, [formData]);
  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.post(`${BASE_URL}/wfm/salarydataadd/`, formData);

        if (res.status === 200) {
          await getSalaryData(code);
          await getSalaryStructure();
          handleClose();
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/salarystructureupdateandget/${code}/`,
          formData
        );

        if (res.status === 200) {
          await getSalaryData(code);
          await getSalaryStructure();
          handleClose();
        } else {
          alert(res);
        }
      } catch (err) {
        handleAllError(err)
      } finally {
        setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-view-button model-add"
        title="Add Salary Details"
        onClick={handleShow}
      >
        {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 500 496" fill="none">
            <path d="M496.406 156.637C494.111 154.783 477.489 143.796 468.822 137.923V118.433C468.822 103.176 456.406 90.76 441.153 90.76H398.622L277.339 9.28002C260.728 -1.88598 239.271 -1.88598 222.66 9.28002L101.379 90.761H58.8466C43.5936 90.761 31.1776 103.177 31.1776 118.434V137.923L4.06058 156.141C2.34758 157.287 0.517578 160.417 0.517578 162.682V460.304C0.517578 479.488 16.1236 495.094 35.3036 495.094H464.696C483.876 495.094 499.482 479.488 499.482 460.304V162.683C499.482 160.834 498.514 158.3 496.406 156.637ZM483.776 460.305C483.776 462.885 483.249 465.341 482.317 467.588L332.225 324.952L483.776 180.893V460.305ZM17.6826 467.589C16.7506 465.342 16.2236 462.886 16.2236 460.306V180.892L167.775 324.951L17.6826 467.589ZM91.7536 211.851C91.7536 203.181 98.7556 196.13 107.36 196.13C116.026 196.13 123.081 203.181 123.081 211.851C123.081 220.455 116.026 227.453 107.36 227.453C98.7556 227.453 91.7536 220.456 91.7536 211.851ZM392.525 227.453C383.921 227.453 376.919 220.455 376.919 211.851C376.919 203.181 383.921 196.13 392.525 196.13C401.191 196.13 408.246 203.181 408.246 211.851C408.246 220.456 401.19 227.453 392.525 227.453ZM479.044 163.718L468.821 173.435V156.85L479.044 163.718ZM231.418 22.317C242.706 14.725 257.293 14.725 268.581 22.317L370.454 90.761H129.546L231.418 22.317ZM58.8466 106.466H441.152C447.747 106.466 453.115 111.834 453.115 118.433V188.364L423.475 216.539C423.71 214.998 423.951 213.456 423.951 211.85C423.951 194.522 409.856 180.423 392.524 180.423C375.262 180.423 361.212 194.522 361.212 211.85C361.212 229.112 375.261 243.158 392.524 243.158C393.652 243.158 394.72 242.942 395.818 242.826L317.692 317.07H182.307L104.193 242.838C105.249 242.946 106.276 243.158 107.36 243.158C124.692 243.158 138.787 229.113 138.787 211.85C138.787 194.522 124.692 180.423 107.36 180.423C90.0976 180.423 76.0476 194.522 76.0476 211.85C76.0476 213.455 76.2876 214.997 76.5216 216.537L46.8836 188.363V118.432C46.8836 111.835 52.2516 106.466 58.8466 106.466ZM31.1776 156.85V173.435L20.9546 163.718L31.1776 156.85ZM35.3036 479.389C33.1606 479.389 31.1336 478.954 29.2086 478.299L182.307 332.807H317.693L470.791 478.299C468.866 478.954 466.84 479.389 464.696 479.389H35.3036Z" fill="black" />
          </svg> */}
        <svg
          width="20"
          height="21"
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 512 512"
          viewBox="0 0 512 512"
          id="salary"
        >
          <path
            d="M256.092,304.837c37.984,0,68.881-38.148,68.881-85.043c0-0.196-0.023-0.384-0.024-0.579
				c0.001-0.195,0.024-0.383,0.024-0.579c0-46.895-30.898-85.043-68.881-85.043c-38.083,0-69.065,38.148-69.065,85.043
				c0,0.196,0.023,0.384,0.024,0.579c-0.001,0.195-0.024,0.383-0.024,0.579C187.027,266.688,218.009,304.837,256.092,304.837z
				 M256.092,150.456c29.168,0,52.911,30.794,53.153,68.758c-0.242,37.964-23.985,68.758-53.153,68.758
				c-29.275,0-53.094-30.794-53.337-68.758C202.998,181.25,226.817,150.456,256.092,150.456z"
          ></path>
          <path
            d="M257.288,242.152h-17.677c-4.341,0-7.853,3.516-7.853,7.853c0,4.337,3.512,7.853,7.853,7.853h8.558v2.719
				c0,4.337,3.512,7.853,7.853,7.853s7.853-3.516,7.853-7.853v-3.798c9.431-2.853,16.365-11.526,16.365-21.881
				c0-12.657-10.299-22.957-22.953-22.957c-0.787,0-3.363,0-2.577,0c-3.995,0-7.247-3.255-7.247-7.255
				c0-3.999,3.252-7.251,7.247-7.251h17.677c4.341,0,7.853-3.516,7.853-7.853c0-4.337-3.512-7.853-7.853-7.853h-8.512v-2.719
				c0-4.337-3.512-7.853-7.853-7.853s-7.853,3.516-7.853,7.853v3.784c-9.456,2.838-16.411,11.522-16.411,21.891
				c0,12.661,10.299,22.96,22.953,22.96h2.577c3.995,0,7.247,3.252,7.247,7.251S261.284,242.152,257.288,242.152z"
          ></path>
          <path
            d="M502.406,164.637c-2.295-1.854-18.917-12.841-27.584-18.714v-19.49c0-15.257-12.416-27.673-27.669-27.673h-42.531
				L283.339,17.28c-16.611-11.166-38.068-11.166-54.679,0L107.379,98.761H64.847c-15.253,0-27.669,12.416-27.669,27.673v19.489
				l-27.117,18.218c-1.713,1.146-3.543,4.276-3.543,6.541v297.622c0,19.184,15.606,34.79,34.786,34.79h429.392
				c19.18,0,34.786-15.606,34.786-34.79V170.683C505.482,168.834,504.514,166.3,502.406,164.637z M489.776,468.305
				c0,2.58-0.527,5.036-1.459,7.283L338.225,332.952l151.551-144.059V468.305z M23.683,475.589
				c-0.932-2.247-1.459-4.703-1.459-7.283V188.892l151.551,144.059L23.683,475.589z M97.754,219.851
				c0-8.67,7.002-15.721,15.606-15.721c8.666,0,15.721,7.051,15.721,15.721c0,8.604-7.055,15.602-15.721,15.602
				C104.756,235.453,97.754,228.456,97.754,219.851z M398.525,235.453c-8.604,0-15.606-6.998-15.606-15.602
				c0-8.67,7.002-15.721,15.606-15.721c8.666,0,15.721,7.051,15.721,15.721C414.246,228.456,407.19,235.453,398.525,235.453z
				 M485.044,171.718l-10.223,9.717V164.85L485.044,171.718z M237.418,30.317c11.288-7.592,25.875-7.592,37.163,0l101.873,68.444
				H135.546L237.418,30.317z M64.847,114.466h382.305c6.595,0,11.963,5.368,11.963,11.967v69.931l-29.64,28.175
				c0.235-1.541,0.476-3.083,0.476-4.689c0-17.328-14.095-31.427-31.427-31.427c-17.262,0-31.312,14.099-31.312,31.427
				c0,17.262,14.049,31.308,31.312,31.308c1.128,0,2.196-0.216,3.294-0.332l-78.126,74.244H188.307l-78.114-74.232
				c1.056,0.108,2.083,0.32,3.167,0.32c17.332,0,31.427-14.045,31.427-31.308c0-17.328-14.095-31.427-31.427-31.427
				c-17.262,0-31.312,14.099-31.312,31.427c0,1.605,0.24,3.147,0.474,4.687l-29.638-28.174v-69.931
				C52.884,119.835,58.252,114.466,64.847,114.466z M37.178,164.85v16.585l-10.223-9.717L37.178,164.85z M41.304,487.389
				c-2.143,0-4.17-0.435-6.095-1.09l153.098-145.492h135.386l153.098,145.492c-1.925,0.655-3.951,1.09-6.095,1.09H41.304z"
          ></path>
        </svg>
      </button>

      <Modal
        show={show}
        onHide={loading ? null : handleClose}
        dialogClassName="request-leave width-40vw"
      >
        {/* <Modal.Header closeButton>
          <Modal.Title>Request Leave</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Finance Details</h6>

              {/* <div className="flex-column">
                <label htmlFor="date" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Date<span className="required">*</span>
                </label>
                <input
                  id="date"
                  type="date"
                  name='date'
                  onChange={handleInputChange}
                  value={formData.date}
                  className={`form-input ${errors.date ? "error" : inputState.date ? "success" : ""
                    }`}
                />
                {errors.date && (
                  <span className="error-message font-size-text ">{errors.date}</span>
                )}
              </div> */}

              <div className="flex-column">
                <label htmlFor="emp_code" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Employee Code
                </label>
                <input
                  id="emp_code"
                  type="text"
                  name="emp_code"
                  placeholder={formData.emp_code}
                  onChange={handleInputChange}
                  readOnly
                  value={formData.emp_code}
                  className={`form-input ${errors.emp_code
                    ? "error"
                    : inputState.emp_code
                      ? "success"
                      : ""
                    }`}
                />
                {errors.emp_code && (
                  <span className="error-message font-size-text ">{errors.emp_code}</span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="basicsalary"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Basic Salary
                </label>
                <input
                  id="basicsalary"
                  name="basicsalary"
                  type="number"
                  onChange={handleInputChange}
                  placeholder="Basic Salary"
                  value={formData.basicsalary}
                  className={`form-input ${errors.basicsalary
                    ? "error"
                    : inputState.basicsalary
                      ? "success"
                      : ""
                    }`}
                />
                {errors.basicsalary && (
                  <span className="error-message font-size-text ">{errors.basicsalary}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="hra" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  HRA
                </label>
                <input
                  id="hra"
                  type="number"
                  name="hra"
                  placeholder="HRA"
                  onChange={handleInputChange}
                  value={formData.hra}
                  className={`form-input ${errors.hra ? "error" : inputState.hra ? "success" : ""
                    }`}
                />
                {errors.hra && (
                  <span className="error-message font-size-text ">{errors.hra}</span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="transport"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Transportation
                </label>
                <input
                  id="transport"
                  type="number"
                  name="transport"
                  placeholder="Transport"
                  onChange={handleInputChange}
                  value={formData.transport}
                  className={`form-input ${errors.transport
                    ? "error"
                    : inputState.transport
                      ? "success"
                      : ""
                    }`}
                />
                {errors.transport && (
                  <span className="error-message font-size-text ">{errors.transport}</span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="specialallowance"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Special Allowance
                </label>
                <input
                  id="specialallowance"
                  type="number"
                  name="specialallowance"
                  placeholder="Special Allowance"
                  onChange={handleInputChange}
                  value={formData.specialallowance}
                  className={`form-input ${errors.specialallowance
                    ? "error"
                    : inputState.specialallowance
                      ? "success"
                      : ""
                    }`}
                />
                {errors.specialallowance && (
                  <span className="error-message font-size-text ">
                    {errors.specialallowance}
                  </span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="bonus" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Bonus
                </label>
                <input
                  id="bonus"
                  type="number"
                  name="bonus"
                  placeholder="Bonus"
                  onChange={handleInputChange}
                  value={formData.bonus}
                  className={`form-input ${errors.bonus ? "error" : inputState.bonus ? "success" : ""
                    }`}
                />
                {errors.bonus && (
                  <span className="error-message font-size-text ">{errors.bonus}</span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button   font-weight500   "
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>

                {salaryData.basicsalary ? (
                  <button
                    type="submit"
                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                    onClick={handleUpdate}
                    disabled={loading}
                  >
                    Update
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AddBankDetails = ({ code, bankData, getBankData }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setFormData(bankData);
  };

  // const [formData, setFormData] = useState({
  //   user: code,
  //   account_number: "s",
  //   ifsc_code: "",
  //   bank_name: "",
  //   branch_address: "",
  // });

  const [formData, setFormData] = useState({
    user: code,
    account_number: "",
    ifsc_code: "",
    bank_name: "",
    branch_address: "",
  });

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "account_number",
      "ifsc_code",
      "bank_name",
      "branch_address",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ?  ************** Validation End **************  ! //

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => { }, [formData]);

  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.post(
          `${BASE_URL}/wfm/userBankDetails/`,
          formData
        );

        if (res.status === 200) {
          await getBankData(code);
          handleClose();
        } else {
          alert(res);
        }
      } catch (err) {
        handleAllError(err);
      } finally {
        setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/wfm/userBankDetails/${code}/`,
          formData
        );

        if (res.status === 200) {
          await getBankData(code);
          handleClose();
        } else {
          alert(res);
        }
      } catch (err) {
        handleAllError(err)
      } finally {
        setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-view-button model-add"
        title="Add Bank Details"
        onClick={handleShow}
      >
        {/* <svg xmlns="http://www.w3.org/2000/svg" id="card" width="24" height="24" x="0" y="0" version="1.1" viewBox="0 0 512 512">
          <path d="M452 96H60c-15.5 0-27.9 12.5-28 28v264c.2 15.5 12.5 28 28 28h392c15.6 0 28-12.7 28-28.3V124.3c0-15.6-12.4-28.3-28-28.3zM77.1 128h357.7c6.9 0 12.1 5.1 13.1 12v20H64v-20.3c1-6.8 6.3-11.7 13.1-11.7zm357.8 256H77.1c-6.9 0-12.1-4.9-13.1-11.7V256h384v116c-1 6.9-6.3 12-13.1 12z"></path>
          <path d="M96 304h192v16H96zM96 336h96v16H96zM352 304h64v48h-64z"></path>
        </svg> */}
        <svg
          width="25"
          height="25"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          id="bank">
          <path d="M15,22a1,1,0,0,0,1-1V18H30v3a1,1,0,0,0,1,1h1v7h2V22h4v7h2V22h1a1,1,0,0,0,1-1V18h1a1,1,0,0,0,1-1V13a1,1,0,0,0-1-1H41V5a3,3,0,0,0-3-3H8A3,3,0,0,0,5,5v7H3a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H4v3a1,1,0,0,0,1,1H6V38H5a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V39a1,1,0,0,0-1-1H14V22Zm25-2H32V18h8ZM7,5A1,1,0,0,1,8,4H38a1,1,0,0,1,1,1v7H7ZM4,14H42v2H4Zm10,4v2H6V18Zm0,24H6V40h8Zm-2-4H8V22h4Zm31-8H27a3,3,0,0,0-3,3V43a3,3,0,0,0,3,3H43a3,3,0,0,0,3-3V33A3,3,0,0,0,43,30Zm1,13a1,1,0,0,1-1,1H27a1,1,0,0,1-1-1V33a1,1,0,0,1,1-1H43a1,1,0,0,1,1,1ZM16,7H30V9H16ZM36,34h2v2H34v1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H36v1H34V42H32V40h4V39H33a1,1,0,0,1-1-1V35a1,1,0,0,1,1-1h1V33h2Z"></path>
        </svg>
      </button>

      <Modal
        show={show}
        onHide={loading ? null : handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Bank Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Bank Details</h6> */}

              {/* <div className="flex-column">
                <label htmlFor="date" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Date<span className="required">*</span>
                </label>
                <input
                  id="date"
                  type="date"
                  name='date'
                  onChange={handleInputChange}
                  value={formData.date}
                  className={`form-input ${errors.date ? "error" : inputState.date ? "success" : ""
                    }`}
                />
                {errors.date && (
                  <span className="error-message font-size-text ">{errors.date}</span>
                )}
              </div> */}

              <div className="flex-column">
                <label htmlFor="user" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                  Employee Code
                </label>
                <input
                  id="user"
                  type="text"
                  name="user"
                  placeholder={formData.user}
                  onChange={handleInputChange}
                  readOnly
                  value={formData.user}
                  className={`form-input ${errors.user ? "error" : inputState.user ? "success" : ""
                    }`}
                />
                {errors.user && (
                  <span className="error-message font-size-text ">{errors.user}</span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="account_number"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Account No.
                </label>
                <input
                  id="account_number"
                  name="account_number"
                  type="number"
                  onChange={handleInputChange}
                  // placeholder="00000"
                  value={formData.account_number}
                  className={`form-input ${errors.account_number
                    ? "error"
                    : inputState.account_number
                      ? "success"
                      : ""
                    }`}
                />
                {errors.account_number && (
                  <span className="error-message font-size-text ">{errors.account_number}</span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="ifsc_code"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  IFSC
                </label>
                <input
                  id="ifsc_code"
                  // type=""
                  name="ifsc_code"
                  // placeholder="00000"
                  onChange={handleInputChange}
                  value={formData.ifsc_code}
                  className={`form-input ${errors.ifsc_code
                    ? "error"
                    : inputState.ifsc_code
                      ? "success"
                      : ""
                    }`}
                />
                {errors.ifsc_code && (
                  <span className="error-message font-size-text ">{errors.ifsc_code}</span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="bank_name"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Bank Name
                </label>
                <input
                  id="bank_name"
                  // type=""
                  name="bank_name"
                  // placeholder="00000"
                  onChange={handleInputChange}
                  value={formData.bank_name}
                  className={`form-input ${errors.bank_name
                    ? "error"
                    : inputState.bank_name
                      ? "success"
                      : ""
                    }`}
                />
                {errors.bank_name && (
                  <span className="error-message font-size-text ">{errors.bank_name}</span>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="branch_address"
                  className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                >
                  Branch Address
                </label>
                <input
                  id="branch_address"
                  // type=""
                  name="branch_address"
                  // placeholder="00000"
                  onChange={handleInputChange}
                  value={formData.branch_address}
                  className={`form-input ${errors.branch_address
                    ? "error"
                    : inputState.branch_address
                      ? "success"
                      : ""
                    }`}
                />
                {errors.branch_address && (
                  <span className="error-message font-size-text ">{errors.branch_address}</span>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button   font-weight500   "
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>

                {bankData.account_number ? (
                  <button
                    type="submit"
                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                    onClick={handleUpdate}
                    disabled={loading}
                  >
                    Update
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const FinanceBackup = ({ financetoggle, email, emp_code }) => {
  const [toggleState, setToggleState] = useState(financetoggle ? financetoggle : 1);
  const { PERMISSION_HR_ADMIN, PERMISSION_AUTHORITY } = usePermission(); // Use the custom hook
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = (today.getMonth() + 1).toString().padStart(2, '0');
  let previousYear = currentYear - 1;
  let previousMonth = today.getMonth();
  if (previousMonth === 0) {
    // previousYear--;
    previousMonth = 12;
  }

  const [selectedMonth, setSelectedMonth] = useState('this month');
  const [selectedYear, setSelectedYear] = useState('this year');
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [buffer2, setBuffering2] = useState(true); //buffering logic
  const [buffer3, setBuffering3] = useState(true); //buffering logic

  const [salaryStructure, setSalaryStructure] = useState([]);
  const getSalaryStructure = async () => {
    setBuffering1(true); // Start Buffering
    const targetMonth = selectedMonth === 'this month' ? currentMonth : previousMonth;
    const targetYear = selectedMonth === 'this month' ? currentYear : previousYear;
    try {
      // const res = await axios.get(
      //   selectedMonth === "this month"
      //     ? `${BASE_URL}/wfm/salaryslipallupcomingbyemp/${currentMonth}/${currentYear}/${emp_code}/`
      //     : `${BASE_URL}/wfm/salaryslipallupcomingbyemp/${previousMonth}/${previousYear}/${emp_code}/`
      // );
      const res = await axios.get(
        `${BASE_URL}/wfm/salaryslipallupcomingbyemp/${targetMonth.toString().padStart(2, '0')}/${targetYear}/${emp_code}/`
      );
      setSalaryStructure(res.data);
    } catch (err) {
      // handleAllError(err)
    } finally {
      setBuffering1(false);// End Buffering
    }
  };
  useEffect(() => {
    getSalaryStructure();
  }, [selectedMonth]);

  const [salarylist, setSalarylist] = useState([]);

  const getSalaryList = async () => {
    setBuffering2(true); // Start Buffering
    try {
      // const res = await axios.get(`${BASE_URL}/wfm/salarylist/${emp_code}/`);sessionStorage
      const res = await axios.get(
        // `${BASE_URL}/wfm/employeesalarysliplist/${emp_code}/`
        selectedYear === "this year"
          ? `${BASE_URL}/wfm/employeesalarysliplistbyyear/${emp_code}/${currentYear}/`
          : `${BASE_URL}/wfm/employeesalarysliplistbyyear/${emp_code}/${previousYear}/`

      );
      setSalarylist(res.data);
    } catch (err) {
      // handleAllError(err)
    } finally {
      setBuffering2(false);// End Buffering
    }
  };

  // console.log(salarylist);
  useEffect(() => {
    getSalaryList();
  }, [selectedYear]);

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const slipUrl = "/" + urlParts[3] + "/dynamicSalarySlip";
  let slip_opener = "profile"


  const ViewSalarySlip = (i, monthh, yearr) => {
    const prevUrl = window.location.pathname;
    navigate(slipUrl, { state: { i, monthh, yearr, slip_opener, prevUrl } });
  };

  const [salaryData, setSalaryData] = useState({});
  const getSalaryData = async (emp_code) => {
    setBuffering3(true); // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/salarystructurebyemp/${emp_code}/`
      );
      setSalaryData(res.data);
    } catch (err) {
      // handleAllError(err)
    } finally {
      setBuffering3(false);// End Buffering
    }
  };
  useEffect(() => {
    getSalaryData(emp_code);
  }, [emp_code]);

  const [bankData, setBankData] = useState({});
  const getBankData = async (emp_code) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/userBankDetailsgetall/${emp_code}/`
      );
      setBankData(res.data);
    } catch (err) {
      // alert(err)
      // handleAllError(err)
      // handleAllError(err)
    }
  };
  useEffect(() => {
    getBankData(emp_code);
  }, [emp_code]);

  const monthOptions = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];
  const getMonthName = (monthNumber) => {
    const month = monthOptions.find((m) => m.id === monthNumber);
    return month ? month.name : "";
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <div
        className="salary-info-container"
      // style={{ display: "flex", justifyContent: "space-between" }}
      >
        {/* Finance Chart */}
        {buffer2 ? <div className="image-loader"></div> :
          < div className="salary-graph">
            <FinanceChart year={selectedYear === "this year" ? currentYear : previousYear} code={emp_code} />
            {/* <Error404Img /> */}
          </div>
        }

        {/* Finance Details */}
        {buffer1 ? <div className="spinner"></div> :
          <div className="finance-secondary-details">

            <div className="finance-top-heading" style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="salary-structure  font-weight500    font-size-heading">Salary Structure</div>
              <div className="radialchart-dropdown">
                <select style={{ border: "none" }} onChange={(e) => { setSelectedMonth(e.target.value) }} value={selectedMonth}>
                  <option value="this month">This Month</option>
                  <option value="last month">Last Month</option>
                </select>
              </div>
            </div>

            <div className="finance-details-cont">
              <div className="fi-cards">
                <div className="finance-heading  font-weight500    font-size-text ">Standard Salary</div>
                <div className="finance-subheading font-weight600  font-size-heading">
                  ₹ {formatCurrencyIndian(salaryStructure?.deduction_details?.find((j) => j.final_salary === true)?.standard_amount || 0)}
                </div>
              </div>
              <div className="fi-cards">
                <div className="finance-heading  font-weight500    font-size-text ">Total Days</div>
                <div className="finance-subheading font-weight600  font-size-heading">
                  {salaryStructure.total_days} Days
                </div>
              </div>
              <div className="fi-cards">
                <div className="finance-heading  font-weight500    font-size-text ">Upcoming Salary</div>
                <div className="finance-subheading font-weight600  font-size-heading">
                  ₹ {formatCurrencyIndian(salaryStructure?.deduction_details?.find((j) => j.final_salary === true)?.actual_amount || 0)}
                </div>
              </div>
              <div className="fi-cards">
                <div className="finance-heading  font-weight500    font-size-text ">Pay Days</div>
                <div className="finance-subheading font-weight600  font-size-heading">
                  {salaryStructure.total_paid_days} Days
                </div>
              </div>
            </div>
          </div>
        }
      </div >

      {financetoggle ? <br /> :
        <div className="bloc-tabss wfm-marginn">
          <button
            className={
              "leave-tab " +
              (toggleState === 1
                ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs font-weight400 font-size-subheading")
            }
            onClick={() => setToggleState(1)}
          >
            Salary Slips
          </button>
          {/* <button
            className={
              "leave-tab " +
              (toggleState === 2
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading")
            }
            onClick={() => setToggleState(2)}
          >
            Advance Slips
          </button> */}
          <button
            className={
              "leave-tab " +
              (toggleState === 3
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading")
            }
            onClick={() => setToggleState(3)}
          >
            Arrear
          </button>
        </div>
      }

      <div className="content-tab-nomargin">
        {toggleState === 1 ? (
          // {/* Finance Slips List */}
          < div className="table-css-white-background" >
            <div className="table-heading-flex">
              <div className="repo-heading font-weight500 font-size-heading">Salary Slip List

                <div className="paymentDashboard-dropdown" style={{ display: "flex", justifyContent: "space-between" }}>
                  {/* <select className='paymentDashboard-a font-size-label' onChange={handleChange} value={selectedMonth}> */}
                  <select style={{ border: "none" }} onChange={(e) => { setSelectedYear(e.target.value) }} value={selectedYear}>
                    <option value="this year">This Year</option>
                    <option value="Last year">Last Year</option>
                  </select>
                </div>
              </div>
              <div className="field-cont">
                {PERMISSION_HR_ADMIN ? (
                  <div className="field-cont">
                    {/* Backup Salary Structure:
                    <PayrollSalaryStructureFormatBackup
                      code={emp_code}
                      salaryData={salaryData}
                      getSalaryData={getSalaryData}
                      getSalaryStructure={getSalaryStructure}
                    />
                    <hr className="field-cont-hr" />
                    Salary Structure old:
                    <PayrollSalaryStructureFormat
                      code={emp_code}
                      salaryData={salaryData}
                      getSalaryData={getSalaryData}
                      getSalaryStructure={getSalaryStructure}
                    />
                    <hr className="field-cont-hr" /> */}
                    Salary Structure:
                    <EmployeePayrollSalaryStructure
                      code={emp_code}
                      salaryData={salaryData}
                      getSalaryData={getSalaryData}
                      getSalaryStructure={getSalaryStructure}
                    />
                    {/* Add Salary Details:{" "}
                    <AddSalaryDetails
                      code={emp_code}
                      salaryData={salaryData}
                      getSalaryData={getSalaryData}
                      getSalaryStructure={getSalaryStructure}
                    /> */}
                    {/* <hr className="field-cont-hr" />
                    Bank Details:
                    <AddBankDetails
                      code={emp_code}
                      bankData={bankData}
                      getBankData={getBankData}
                    /> */}
                  </div>
                ) :
                  null
                }
              </div>
            </div>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="align-left">Sr. No.</th>
                  <th className="align-center">Month</th>
                  <th className="align-center">Year</th>
                  <th className="align-center">Total Pay days</th>
                  <th className="align-center">Net Pay</th>
                  <th className="align-center ">Salary Receipt</th>
                </tr>
              </thead>
              {buffer2 ? <div className="spinner"></div> :
                <tbody>
                  <tr className="tr-border-bottom">
                    <td colSpan={6}></td>
                  </tr>
                  {salarylist
                    .sort((a, b) => a.year - b.year)
                    .sort((a, b) => a.month - b.month)
                    .map((item, index) => {
                      return (
                        <>
                          <tr className="custom-table-head-tdd">
                            <td className="align-left">{index + 1}</td>
                            <td className="align-center">{getMonthName(item.month)}</td>
                            <td className="align-center">{item.year}</td>
                            <td className="align-center">{item.salary_data?.total_paid_days}</td>
                            <td className="align-center">
                              {formatCurrencyIndian(
                                item.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
                              )}
                            </td>
                            <td className="align-center">
                              <button
                                className="allproject-dashboard"
                                title="View using Navigate"
                                onClick={(e) => ViewSalarySlip(item, item.month, item.year)}
                              >
                                <Eye />
                              </button>
                            </td>
                          </tr>
                          <tr className="tr-border-bottom">
                            <td colSpan={6}></td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>}
            </table>
          </div >
        ) : null}

        {/* {toggleState === 2 ? (
         
          < EmployeeAdvanceSlipsTable
            email={email}
            emp_code={emp_code}
          />
        ) : null} */}
        {toggleState === 3 ? (

          <Arreartable
            emp_code={emp_code}
          />
        ) : null}
      </div>
    </>
  );
};


const Finance = ({ financetoggle, email, emp_code }) => {
  const [toggleState, setToggleState] = useState(financetoggle ? financetoggle : 1);
  const { PERMISSION_HR_ADMIN, PERMISSION_AUTHORITY } = usePermission(); // Use the custom hook
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = (today.getMonth() + 1).toString().padStart(2, '0');

  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');

  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [buffer2, setBuffering2] = useState(true); //buffering logic
  const [buffer3, setBuffering3] = useState(true); //buffering logic
  const [buffer4, setBuffering4] = useState(true); //buffering logic


  const [timelineData, setTimelineData] = useState({
    joining_date: '',
    last_working_date: null,
    last_salary_slip: { month: 0, year: 0 },
    last_salary_change: { month: 0, year: 0 },
    last_attendance_date: '',
    last_bank_detail_change: '',
    last_org_detail_change: ''
  });
  const [availableYears, setAvailableYears] = useState([]);
  const [availableMonths, setAvailableMonths] = useState([]);

  // In getTimelineData function:
  const getTimelineData = async () => {
    setBuffering4(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employee-latest-timeline/${emp_code}/`
      );
      setTimelineData(res.data);

      // Generate available years
      const joiningDate = new Date(res.data.joining_date);
      const joiningYear = joiningDate.getFullYear();

      const latestAttendanceDate = res.data.last_attendance_date
        ? new Date(res.data.last_attendance_date)
        : new Date();
      const latestAttendanceYear = latestAttendanceDate.getFullYear();

      const years = [];
      for (let year = joiningYear; year <= latestAttendanceYear; year++) {
        years.push(year.toString());
      }
      setAvailableYears(years);

      // Set initial year
      // const initialYear = years.includes(currentYear) ? currentYear : years[years.length - 1];
      const initialYear = years.includes(currentYear) ? currentYear.toString() : years[years.length - 1].toString();
      setSelectedYear(initialYear);

      // Update available months using complete timeline object
      updateAvailableMonths(initialYear, res.data);
      getSalaryList(initialYear);
    } catch (err) {
      console.error("Error fetching timeline data:", err);
    } finally {
      setBuffering4(false);
    }
  };

  const updateAvailableMonths = (year, timelineData) => {
    if (!timelineData || !timelineData.joining_date || !timelineData.last_attendance_date) {
      return;
    }

    const months = [];

    const joiningDate = new Date(timelineData.joining_date);
    const joiningYear = joiningDate.getFullYear();
    const joiningMonth = joiningDate.getMonth() + 1;

    const latestAttendanceDate = new Date(timelineData.last_attendance_date);
    const latestAttendanceYear = latestAttendanceDate.getFullYear();
    const latestAttendanceMonth = latestAttendanceDate.getMonth() + 1;

    const yearNum = parseInt(year);

    const currentDate = new Date();
    const currentYearNum = currentDate.getFullYear();
    const currentMonthNum = currentDate.getMonth() + 1;
    let endMonth = latestAttendanceMonth;
    if (yearNum === currentYearNum && currentYearNum === latestAttendanceYear) {
      endMonth = Math.max(latestAttendanceMonth, currentMonthNum);
    }

    // If it's the same year (joining = latest attendance year)
    if (joiningYear === latestAttendanceYear && yearNum === joiningYear) {
      // Show months from joining month to end month (latest attendance or current month)
      const startMonth = Math.max(joiningMonth, 1);
      const finalEndMonth = Math.min(endMonth, 12);
      for (let month = startMonth; month <= finalEndMonth; month++) {
        months.push(month);
      }
    }
    // For joining year
    else if (yearNum === joiningYear) {
      // Show months from joining month to December
      for (let month = joiningMonth; month <= 12; month++) {
        months.push(month);
      }
    }
    // For latest attendance year
    else if (yearNum === latestAttendanceYear) {
      // Show months from January to end month (latest attendance or current month)
      for (let month = 1; month <= endMonth; month++) {
        months.push(month);
      }
    }
    // For latest attendance year
    else if (yearNum === latestAttendanceYear) {
      // Show months from January to latest attendance month
      for (let month = 1; month <= latestAttendanceMonth; month++) {
        months.push(month);
      }
    }
    // For years in between (not joining year and not latest attendance year)
    else if (yearNum > joiningYear && yearNum < latestAttendanceYear) {
      // Show all months for intermediate years
      for (let month = 1; month <= 12; month++) {
        months.push(month);
      }
    }

    setAvailableMonths(months);

    // Set selected month to last available month if current selection is invalid
    if (!selectedMonth || !months.includes(parseInt(selectedMonth))) {
      const lastAvailableMonth = months.length > 0 ? months[months.length - 1] : 1;
      setSelectedMonth(lastAvailableMonth.toString().padStart(2, '0'));
    }
  };


  const [salaryStructure, setSalaryStructure] = useState([]);
  const getSalaryStructure = async () => {
    if (!selectedMonth || !selectedYear) return;

    setBuffering1(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/salaryslip-upcomingdata-byemp/${selectedMonth}/${selectedYear}/${emp_code}/`
      );
      setSalaryStructure(res.data);
    } catch (err) {
      console.error("Error fetching salary structure:", err);
    } finally {
      setBuffering1(false);
    }
  };

  useEffect(() => {
    if (selectedMonth && selectedYear) {
      getSalaryStructure();
    }
  }, [selectedMonth, selectedYear]);


  const [salarylist, setSalarylist] = useState([]);
  // const getSalaryList = async () => {
  //   setBuffering2(true); // Start Buffering
  //   try {
  //     const res = await axios.get(
  //       `${BASE_URL}/wfm/employeesalarysliplistbyyear/${emp_code}/${selectedYear}/`
  //     );
  //     setSalarylist(res.data);
  //   } catch (err) {
  //     // handleAllError(err)
  //     console.error("Error fetching salary list:", err);
  //   } finally {
  //     setBuffering2(false);// End Buffering
  //   }
  // };

  const getSalaryList = async (year) => {
    const yearToUse = year || selectedYear;
    if (!yearToUse) return; // guard add karo

    setBuffering2(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employeesalarysliplistbyyear/${emp_code}/${yearToUse}/`
      );
      setSalarylist(res.data);
    } catch (err) {
      console.error("Error fetching salary list:", err);
    } finally {
      setBuffering2(false);
    }
  };

  // console.log(salarylist);
  useEffect(() => {
    if (selectedYear) {
      getSalaryList();
    }
  }, [selectedYear]);

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const slipUrl = "/" + urlParts[3] + "/dynamicSalarySlip";
  let slip_opener = "profile"


  const ViewSalarySlip = (i, monthh, yearr) => {
    const prevUrl = window.location.pathname;
    navigate(slipUrl, { state: { i, monthh, yearr, slip_opener, prevUrl } });
  };

  const [salaryData, setSalaryData] = useState({});
  const getSalaryData = async (emp_code) => {
    setBuffering3(true); // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/salarystructurebyemp/${emp_code}/`
      );
      setSalaryData(res.data);
    } catch (err) {
      // handleAllError(err)
    } finally {
      setBuffering3(false);// End Buffering
    }
  };

  useEffect(() => {
    getTimelineData();
    getSalaryData(emp_code);
  }, [emp_code]);

  const [bankData, setBankData] = useState({});
  const getBankData = async (emp_code) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/userBankDetailsgetall/${emp_code}/`
      );
      setBankData(res.data);
    } catch (err) {
      // alert(err)
      // handleAllError(err)
      // handleAllError(err)
    }
  };
  useEffect(() => {
    getBankData(emp_code);
  }, [emp_code]);

  const monthOptions = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];
  const getMonthName = (monthNumber) => {
    const month = monthOptions.find((m) => m.id === monthNumber);
    return month ? month.name : "";
  };

  const handleYearChange = (e) => {
    const newYear = e.target.value;
    setSelectedYear(newYear);

    // Update available months for the new year
    const joiningDate = new Date(timelineData.joining_date);
    const joiningYear = joiningDate.getFullYear();
    const joiningMonth = joiningDate.getMonth() + 1;

    const lastAttendanceDate = timelineData.last_attendance_date
      ? new Date(timelineData.last_attendance_date)
      : new Date();
    const lastYear = lastAttendanceDate.getFullYear();
    const lastMonth = lastAttendanceDate.getMonth() + 1;

    // updateAvailableMonths(newYear, joiningYear, joiningMonth, lastYear, lastMonth);
    updateAvailableMonths(newYear, timelineData);

  };

  const monthlyTdsRaw = Number(
    salaryStructure?.tax_details?.full_details?.calculation_tax_details
      ?.final_monthly_tds_after_adjustment_from_proof ?? 0
  );

  const salaryAmountRaw = Number(
    salaryStructure?.salary_details?.deduction_details
      ?.find((j) => j.is_final === true)?.base_amount ?? 0
  );

  const arrearRaw = Number(
    salaryStructure?.tax_details?.full_details?.calculation_tax_details
      ?.current_arrear_details?.total_arrear_amount ?? 0
  );

  const finalAmountRaw = salaryAmountRaw + arrearRaw - monthlyTdsRaw;

  const UpcomingsalaryAmountRaw = Number(
    salaryStructure?.salary_details?.deduction_details
      ?.find((j) => j.is_final === true)?.prorated_amount ?? 0
  );


  const upcomingSalaryAmount = formatCurrencyIndian(UpcomingsalaryAmountRaw);

  const finalUpcomingAmountRaw = UpcomingsalaryAmountRaw + arrearRaw - monthlyTdsRaw;


  const monthlyTds = formatRoundoff2D(monthlyTdsRaw);
  const salaryAmount = formatCurrencyIndian(salaryAmountRaw);
  const arrear = formatRoundoff2D(arrearRaw);

  console.log(salarylist, "salarylist");

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      {/* <div className="finance-top-heading" style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="salary-structure  font-weight500    font-size-heading">Salary Structure And Details</div>
        <div className="radialchart-dropdown">
          <select style={{ border: "none" }} onChange={(e) => { setSelectedMonth(e.target.value) }} value={selectedMonth}>
            <option value="this month">This Month</option>
            <option value="last month">Last Month</option>
          </select>
        </div>
      </div> */}

      <div className="flex-row justify-between bloc-tabss ">
        <div className=" salary-structure font-weight500 font-size-heading">
          Salary & Finance Details
        </div>
        <div className="salary-structure flex-row">
          {/* Year : */}

          <div className=" font-weight400 font-size-subheading">
            {buffer4 ? (
              <div className="spinner-small"></div>
            ) : (

              <select
                style={{ border: "none" }}
                // className={`form-input-background  `}
                className={`priority-button `}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {availableYears.map(year => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
      </div>

      <div
        className="salary-info-container"
      // style={{ display: "flex", justifyContent: "space-between" }}
      >
        {/* Finance Chart */}
        {buffer2 ? <div className="image-loader"></div> :
          < div className="salary-graph">
            {/* <FinanceChart year={selectedYear === "this year" ? currentYear : previousYear} code={emp_code} /> */}
            <FinanceChart year={selectedYear} code={emp_code} />
            {/* <Error404Img /> */}
          </div>
        }

        {/* Finance Details */}
        {buffer1 ? <div className="spinner"></div> :
          <div className="finance-secondary-details">

            <div className="finance-top-heading" style={{ display: "flex", justifyContent: "space-between" }}>
              {/* <div className="salary-structure  font-weight500    font-size-heading">Salary Structure</div> */}
              <div className="salary-structure font-weight500 font-size-heading">
                {/* Salary Applicable for {selectedMonth ? getMonthName(parseInt(selectedMonth)) : ''}-{selectedYear} */}
                Salary Applicable for month
              </div>
              <div className="radialchart-dropdown">
                {buffer4 ? (
                  <div className="spinner-small"></div>
                ) : (
                  <select
                    style={{ border: "none" }}
                    onChange={(e) => { setSelectedMonth(e.target.value) }}
                    value={selectedMonth}
                    disabled={!selectedYear}
                  >
                    {availableMonths.map(month => (
                      <option key={month} value={month.toString().padStart(2, '0')}>
                        {getMonthName(month)}, {selectedYear}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            </div>

            <div className="finance-details-cont">
              <div className="fi-cards">
                <div className="finance-heading font-weight500 font-size-text ">Standard Salary</div>
                <div className="finance-subheading font-weight600 font-size-heading">

                  {/* ₹ {formatCurrencyIndian(salaryStructure?.salary_details?.deduction_details?.find((j) => j.final_salary === true)?.standard_amount || 0)} */}
                  {/* ₹ {formatCurrencyIndian(salaryStructure?.salary_details?.deduction_details?.find((j) => j.is_final === true)?.base_amount || 0)} */}

                  <td className="align-center">
                    <CustomTooltip position="top"
                      tooltipContent={
                        <div className="tds-tooltip">
                          <div><strong>Monthly Salary:</strong> ₹{salaryAmount}</div>
                          <div><strong>Arrear:</strong> ₹{arrear}</div>
                          <div><strong>TDS:</strong> ₹{monthlyTds}</div>


                        </div>

                      }
                    >
                      <span className="cursor-pointer">
                        {/* ₹ {formatCurrencyIndian(salaryStructure?.salary_details?.deduction_details?.find((j) => j.is_final === true)?.base_amount || 0)} */}
                        ₹ {formatRoundoffComplete(finalAmountRaw)}

                      </span>
                    </CustomTooltip>
                  </td>
                </div>
              </div>
              <div className="fi-cards">
                <div className="finance-heading  font-weight500    font-size-text ">Total Days</div>
                <div className="finance-subheading font-weight600  font-size-heading">
                  {salaryStructure.total_days} Days
                </div>
              </div>
              <div className="fi-cards">
                <div className="finance-heading  font-weight500    font-size-text ">Upcoming Salary</div>
                <div className="finance-subheading font-weight600  font-size-heading">
                  {/* ₹ {formatCurrencyIndian(salaryStructure?.salary_details?.deduction_details?.find((j) => j.final_salary === true)?.actual_amount || 0)} */}
                  {/* ₹ {formatCurrencyIndian(salaryStructure?.salary_details?.deduction_details?.find((j) => j.is_final === true)?.prorated_amount || 0)} */}
                  <td className="align-center">
                    <CustomTooltip position="top"
                      tooltipContent={
                        <div className="tds-tooltip">
                          <div><strong>Monthly Salary:</strong> ₹{upcomingSalaryAmount}</div>
                          <div><strong>Arrear:</strong> ₹{arrear}</div>
                          <div><strong>TDS:</strong> ₹{monthlyTds}</div>


                        </div>

                      }
                    >
                      <span className="cursor-pointer">
                        {/* ₹ {formatCurrencyIndian(salaryStructure?.salary_details?.deduction_details?.find((j) => j.is_final === true)?.base_amount || 0)} */}
                        ₹ {formatRoundoffComplete(finalUpcomingAmountRaw)}

                      </span>
                    </CustomTooltip>
                  </td>
                </div>
              </div>
              <div className="fi-cards">
                <div className="finance-heading  font-weight500    font-size-text ">Pay Days</div>
                <div className="finance-subheading font-weight600  font-size-heading">
                  {salaryStructure.paid_days} Days
                </div>
              </div>
            </div>
          </div>
        }
      </div >

      {financetoggle ? <br /> :
        <div className="bloc-tabss wfm-marginn">
          <button
            className={
              "leave-tab " +
              (toggleState === 1
                ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs font-weight400 font-size-subheading")
            }
            onClick={() => setToggleState(1)}
          >
            Salary Slips
          </button>
          {/* <button
            className={
              "leave-tab " +
              (toggleState === 2
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading")
            }
            onClick={() => setToggleState(2)}
          >
            Advance Slips
          </button> */}
          <button
            className={
              "leave-tab " +
              (toggleState === 3
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading")
            }
            onClick={() => setToggleState(3)}
          >
            Arrear
          </button>
        </div>
      }

      <div className="content-tab-nomargin">
        {toggleState === 1 ? (
          // {/* Finance Slips List */}
          < div className="table-css-white-background" >
            <div className="table-heading-flex">
              <div className="repo-heading font-weight500 font-size-heading flex-row justify-between">
                <div>
                  Salary Slip List
                </div>

              </div>
              <div className="field-cont">
                <div className="paymentDashboard-dropdown" style={{ display: "flex", justifyContent: "space-between" }}>
                  {buffer4 ? (
                    <div className="spinner-small"></div>
                  ) : (
                    <select
                      style={{ border: "none" }}
                      onChange={handleYearChange}
                      value={selectedYear}
                    >
                      {availableYears.map(year => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  )}
                  <hr className="field-cont-hr" />
                </div>
                {PERMISSION_HR_ADMIN ? (
                  <div className="field-cont">
                    {/* Backup Salary Structure:
                    <PayrollSalaryStructureFormatBackup
                      code={emp_code}
                      salaryData={salaryData}
                      getSalaryData={getSalaryData}
                      getSalaryStructure={getSalaryStructure}
                    />
                    <hr className="field-cont-hr" />
                    Salary Structure old:
                    <PayrollSalaryStructureFormat
                      code={emp_code}
                      salaryData={salaryData}
                      getSalaryData={getSalaryData}
                      getSalaryStructure={getSalaryStructure}
                    />
                    <hr className="field-cont-hr" /> */}
                    Salary Structure:
                    <EmployeePayrollSalaryStructure
                      code={emp_code}
                      salaryData={salaryData}
                      getSalaryData={getSalaryData}
                      getSalaryStructure={getSalaryStructure}
                    />
                    {/* Add Salary Details:{" "}
                    <AddSalaryDetails
                      code={emp_code}
                      salaryData={salaryData}
                      getSalaryData={getSalaryData}
                      getSalaryStructure={getSalaryStructure}
                    /> */}
                    {/* <hr className="field-cont-hr" />
                    Bank Details:
                    <AddBankDetails
                      code={emp_code}
                      bankData={bankData}
                      getBankData={getBankData}
                    /> */}
                  </div>
                ) :
                  null
                }
              </div>
            </div>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="align-left">Sr. No.</th>
                  <th className="align-center">Month</th>
                  <th className="align-center">Year</th>
                  <th className="align-center">Total Pay days</th>
                  <th className="align-center">Monthly Salary</th>
                  <th className="align-center">Arrear</th>
                  <th className="align-center">Monthly TDS</th>

                  <th className="align-center">Salary Receipt</th>
                </tr>
              </thead>
              {buffer2 ? <div className="spinner"></div> :
                <tbody>
                  <tr className="tr-border-bottom">
                    <td colSpan={6}></td>
                  </tr>
                  {salarylist
                    .sort((a, b) => a.year - b.year)
                    .sort((a, b) => a.month - b.month)
                    .map((item, index) => {
                      return (
                        <>
                          <tr className="custom-table-head-tdd">
                            <td className="align-left">{index + 1}</td>
                            <td className="align-center">{getMonthName(item.month)}</td>
                            <td className="align-center">{item.year}</td>
                            <td className="align-center">{item.salary_data?.total_paid_days}</td>
                            <td className="align-center">
                              {formatRoundoffComplete(
                                item.salary_data?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
                              )}
                            </td>
                            <td className="align-center">{formatRoundoffComplete(item.tds_data?.calculation_tax_details?.current_arrear_details?.total_arrear_amount)}</td>
                            <td className="align-center">{formatRoundoffComplete(item.tds_data?.calculation_tax_details?.final_tax_summary?.final_monthly_tds)}</td>

                            <td className="align-center">
                              <button
                                className="allproject-dashboard"
                                title="View using Navigate"
                                onClick={(e) => ViewSalarySlip(item, item.month, item.year)}
                              >
                                <Eye />
                              </button>
                            </td>
                          </tr>
                          <tr className="tr-border-bottom">
                            <td colSpan={6}></td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>}
            </table>
          </div >
        ) : null}

        {/* {toggleState === 2 ? (
         
          < EmployeeAdvanceSlipsTable
            email={email}
            emp_code={emp_code}
          />
        ) : null} */}
        {toggleState === 3 ? (

          <Arreartable
            emp_code={emp_code}
          />
        ) : null}
      </div>
    </>
  );
};

export default Finance;
